import Block from '../block'

export default class BlockVideo extends Block {
	static title = 'block-video'

	constructor($el) {
		super($el)

		this.image = this.$el.findElement('thumbnail')
		this.iframe = this.$el.findElement('iframe').find('iframe')

		this.image.on('click', () => {
			this.createVideo()
		})

		const checkScroll = () => {
			if (!this.$el.hasModifier('activated')) {
				if (this.inView()) {
					this.createVideo()
				} else {
					$(document).one('scroll resize', checkScroll)
				}
			}
		}
		$(document).one('scroll resize', checkScroll)
		checkScroll()
	}

	createVideo() {
		this.iframe.prop('src', this.iframe.data('src'))
		this.image.addClass('hidden')
		this.$el.addModifier('activated')
	}

	inView() {
		const elTop = this.$el.offset().top
		const elBot = elTop + this.$el.outerHeight()

		const viewportTop = $(window).scrollTop()
		const viewportBot = viewportTop + $(window).height()

		if (elBot > viewportTop && elTop < viewportBot) {
			return true
		} else {
			return false
		}
	}
}
